module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKBAMAAABPkMOvAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURa2tra2trUdwTK2tra2tra2tra2trXnnQxgAAAAGdFJOU94eALr4hRA8NPEAAAAJcEhZcwAAAEgAAABIAEbJaz4AAAA/SURBVAjXYwhJAwNXBjcII4XBDMJIZhCAMBgZFNlAdIIQgxJYiFGJQQkklCAEZICEGJVADEU2oACIoSRsCCQAY8sU2x8gwBwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/user/pulldown.png
// module id = 857
// module chunks = 0